import type { FaireProductEntity } from "../../entity_types/product";

export const p_pbdpcgqkw9: FaireProductEntity = {
  token: "p_pbdpcgqkw9",
  type: "product",
  name: "de la Paz Big City blend",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/396de04eb03d9390bdecf19125efaca4ed11fe57ebec7dc6be95ec729470fd20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00240da7659c660bf4f2e19866bcd7dc9b99384aab32ddefbc5573d37ea3454b.jpeg",
    "https://cdn.faire.com/fastly/ce7d786c2293450403f5bbb042ddd045844d2494727dc2ffe77faba9ebc795ac.jpeg",
    "https://cdn.faire.com/fastly/b65e31ad1ed828f6c78bfee1a606201dc05debffe69ea5adad702ee8781f3148.jpeg"
  ],
  priceDollars: 26,
  description: "Dark chocolate, molasses, pecan pie\n\nThis big, blue, bold, and bodacious blend is the deepest, darkest, and most developed de la Paz offering... which isn't to say it's anywhere near the oily waste of chain-roasted coffee. It's just a heavy, syrupy, and slightly smoky blend that asserts itself like any big city citizen.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:07.902Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
